import * as React from "react"
export const ToolbarDof = (props:any ) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
        fill="none"
     viewBox="0 0 20 20"
    {...props}
  >
    <g >
      <path
        fill="#6C757D"
        d="M10 0C4.478 0 0 4.478 0 10c0 5.523 4.478 10 10 10 5.523 0 10-4.477 10-10 0-5.522-4.477-10-10-10Zm1.174 1.75A8.338 8.338 0 0 1 16.663 5H9.194l1.98-3.25Zm.653 4.916 2.027 3.337-2.03 3.33H8.12L6.197 9.916l1.981-3.251h3.649ZM9.253 1.702 5.26 8.252l-1.868-3.32a8.33 8.33 0 0 1 5.861-3.23Zm-6.89 11.631A8.285 8.285 0 0 1 1.667 10c0-1.22.263-2.38.737-3.426l3.804 6.76H2.363Zm6.463 4.917A8.342 8.342 0 0 1 3.337 15h7.47l-1.981 3.25Zm1.921.05 4.08-6.693 1.959 3.225a8.334 8.334 0 0 1-6.039 3.467Zm3.029-11.634h3.86A8.29 8.29 0 0 1 18.334 10c0 1.114-.22 2.178-.619 3.15l-3.938-6.484Z"
      />
    </g>

  </svg>
)
